/**
 * Application routes configuration
 * Centralizes all route definitions for better management
 */
const ROUTES = {
  HOME: '/',
  ABOUT_US: {
    ROOT: '/about-us',
    CSR: '/about-us/csr'
  },
  STRATEGIES: {
    ROOT: '/strategies',
    INVESTMENT_PROGRAMS: '/strategies/quantitative-strategies',
    TRADING_BUSINESS: '/strategies/trading-business-vision',
    STRAND_Q: '/strategies/strand-q',
    MERIN: '/strategies/merin',
    DRAVON: '/strategies/dravon',
    GLOBAL_MACRO: '/strategies/global-macro',
    AMC: '/strategies/amc'
  },
  HOW_TO_JOIN: {
    ROOT: '/how-to-join',
    INTERNSHIP: '/how-to-join/internship',
    INTERVIEW: '/how-to-join/interview',
    PREPARING_INTERVIEW: '/how-to-join/interview/preparing-for-interview',
    UK_RECRUITMENT: '/how-to-join/uk-recruitment-policy',
    EU_RECRUITMENT: '/how-to-join/eu-recruitment-policy',
    JOB_DETAILS: '/how-to-join/:jobId'
  },
  AUTH: '/auth',
  SENTINEL_SIGNALS: '/auth/signals',
  LIBRARY: '/library',
  BLOG: {
    ROOT: '/blog',
    POST: '/blog/:id'
  },
  CONTACT: '/contact',
  SITEMAP: '/sitemap', // Internal development page
  LEGAL: {
    ROOT: '/legal',
    COOKIE_POLICY: '/legal/cookie-policy',
    IMPORTANT_DISCLOSURES: '/legal/important-disclosures',
    TAX_STRATEGY: '/legal/tax-strategy',
    MODERN_SLAVERY: '/legal/modern-slavery-statement',
    TERMS: '/legal/terms-and-conditions',
    RECRUITMENT_POLICY: '/legal/recruitment-policy-notice',
    PRIVACY: '/legal/online-privacy-statement'
  },
  // 404 Page
  NOT_FOUND: '/404'
};

export default ROUTES;
